package com.castly.admin.ui.components

import androidx.compose.runtime.*
import com.castly.admin.ui.theme.AppTheme
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Tooltip(
    text: String,
    content: @Composable () -> Unit
) {
    var isVisible by remember { mutableStateOf(false) }
    val isDark = AppTheme.isDark

    Div({
        style {
            property("position", "relative")
            display(DisplayStyle.InlineBlock)
        }
        onMouseEnter { isVisible = true }
        onMouseLeave { isVisible = false }
    }) {
        content()

        if (isVisible) {
            Span({
                attr("role", "tooltip")
                style {
                    property("position", "absolute")
                    property("bottom", "100%")
                    property("left", "50%")
                    property("transform", "translateX(-50%)")
                    marginBottom(6.px)
                    padding(6.px, 10.px)
                    backgroundColor(Color(if (isDark) "#e2e8f0" else "#1f2937"))
                    color(Color(if (isDark) "#1f2937" else "#e2e8f0"))
                    borderRadius(4.px)
                    fontSize(12.px)
                    property("white-space", "nowrap")
                    property("z-index", "9999")
                    property("pointer-events", "none")
                    property("opacity", "1")
                    property("transition", "opacity 0.15s ease")
                }
            }) { Text(text) }
        }
    }
}
